import React from 'react';
import styles from "./Accordion.module.scss";


const Accordion = ({ id, show, onShow, title, children }) => {

    const handleShow = () => onShow && onShow(id);
  
    return (

     <div className={`${styles.accordionItem}`}>
        <div className={`${styles.accordionTitle} ${show ? styles.open : ""}`} onClick={handleShow}>
          <div>{title}</div>
          <div>{show ? '-' : '+'}</div>
        </div>
        {show && <div className={styles.accordionContent}>{children}</div>}
      </div>
    );
  };
  
  export default Accordion;